import { db } from "./firebase";
import {
  doc, getDoc, setDoc, updateDoc,
  collection, addDoc, query, where, getDocs, orderBy
} from "firebase/firestore";

export const createBankAccount = async (accountId, ownerName, initialBalance, userId) => {
  await setDoc(doc(db, "accounts", accountId), {
    accountId,
    ownerName,
    balance: initialBalance,
    userId,
    createdAt: new Date().toISOString(),
  });
  await addDoc(collection(db, "transactions"), {
    accountId,
    message: `Account created with balance: ₹${initialBalance}`,
    type: "system",
    amount: initialBalance,
    createdAt: new Date().toISOString(),
  });
};

export const getAccount = async (accountId) => {
  const snap = await getDoc(doc(db, "accounts", accountId));
  return snap.exists() ? snap.data() : null;
};

export const getAllAccounts = async () => {
  const snap = await getDocs(collection(db, "accounts"));
  return snap.docs.map(d => d.data());
};

export const deposit = async (accountId, amount) => {
  const ref = doc(db, "accounts", accountId);
  const snap = await getDoc(ref);
  if (!snap.exists()) throw new Error("Account not found");
  const newBalance = snap.data().balance + amount;
  await updateDoc(ref, { balance: newBalance });
  await addDoc(collection(db, "transactions"), {
    accountId,
    message: `Deposited: ₹${amount} | Balance: ₹${newBalance}`,
    type: "credit",
    amount,
    createdAt: new Date().toISOString(),
  });
};

export const withdraw = async (accountId, amount) => {
  const ref = doc(db, "accounts", accountId);
  const snap = await getDoc(ref);
  if (!snap.exists()) throw new Error("Account not found");
  if (snap.data().balance < amount) throw new Error("Insufficient funds");
  const newBalance = snap.data().balance - amount;
  await updateDoc(ref, { balance: newBalance });
  await addDoc(collection(db, "transactions"), {
    accountId,
    message: `Withdrew: ₹${amount} | Balance: ₹${newBalance}`,
    type: "debit",
    amount,
    createdAt: new Date().toISOString(),
  });
};

export const getHistory = async (accountId) => {
  const q = query(
    collection(db, "transactions"),
    where("accountId", "==", accountId),
    orderBy("createdAt", "asc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data().message);
};